import React from 'react';
import { DqText } from '../../dq-text';
import { Color } from '@ionic/core';
import { AppModal } from '../app-modal/AppModal';

export interface YesNoProps {
  /** Opens the modal */
  isOpen: boolean;

  /** The title of the modal. */
  title: string;

  /** The description of the modal */
  description: string;

  /** The text to display in the "yes" button */
  yesButtonText: string;

  /** The color of the "yes" option. */
  yesButtonColor?: Color & string;

  /** The text to display in the "no" buttons */
  noButtonText: string;

  /** Determines if the "close" button is available. */
  displayCloseButton: boolean;

  /** Handles the close actions from the app. */
  close: (isYes: boolean) => any;
}
/**
 * A simple modal that allows for a yes/no action from the user.
 */
export const YesNoModal: React.FC<YesNoProps> = (props: YesNoProps) => {
  return (
    <AppModal
      isOpen={props.isOpen}
      title={props.title}
      onClose={() => props.close(false)}
      primaryButton={{
        label: props.yesButtonText,
        onClick: () => props.close(true),
      }}
      secondaryButton={{
        label: props.noButtonText,
        onClick: () => props.close(false),
      }}
    >
      <div className="inner-content ion-padding">
        <DqText color="medium" variant="body">
          {props.description}
        </DqText>
      </div>
    </AppModal>
  );
};
